(() => {
  const popup = document.querySelector('[data-hydros-promo]');
  if (!popup) return;

  const code = popup.dataset.code || 'SOURCE15';
  const delay = Number(popup.dataset.delay) || 10000;
  const scrollPercent = Number(popup.dataset.scroll) || 35;
  const memoryDays = Number(popup.dataset.memoryDays) || 7;
  const storageKey = `hydros:welcome-offer:${code}`;
  const isPreviewMode = new URLSearchParams(window.location.search).get('hydros_promo') === 'preview';
  let hasOpened = false;
  let timer;

  const wasRecentlyDismissed = () => {
    if (isPreviewMode) return false;
    try {
      const dismissedAt = Number(window.localStorage.getItem(storageKey));
      return dismissedAt > 0 && Date.now() - dismissedAt < memoryDays * 86400000;
    } catch (error) {
      return false;
    }
  };

  const rememberDismissal = () => {
    try {
      window.localStorage.setItem(storageKey, String(Date.now()));
    } catch (error) {
      // The offer still closes when storage is unavailable.
    }
  };

  const stopTriggers = () => {
    window.clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
  };

  const show = () => {
    if (hasOpened || wasRecentlyDismissed()) return;
    hasOpened = true;
    stopTriggers();
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    window.requestAnimationFrame(() => popup.classList.add('is-visible'));
  };

  const dismiss = () => {
    rememberDismissal();
    stopTriggers();
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    window.setTimeout(() => {
      popup.hidden = true;
    }, 220);
  };

  const onScroll = () => {
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable <= 0) return;
    if ((window.scrollY / scrollable) * 100 >= scrollPercent) show();
  };

  const copyCode = async (button) => {
    try {
      await navigator.clipboard.writeText(code);
    } catch (error) {
      const field = document.createElement('textarea');
      field.value = code;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      document.execCommand('copy');
      field.remove();
    }

    const label = button.querySelector('.hydros-promo__copy-label');
    if (label) label.textContent = 'Code copié';
    button.classList.add('is-copied');
    window.setTimeout(() => {
      if (label) label.textContent = 'Copier';
      button.classList.remove('is-copied');
    }, 1800);
  };

  popup.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-hydros-promo-close]');
    if (closeButton) {
      dismiss();
      return;
    }

    const copyButton = event.target.closest('[data-hydros-promo-copy]');
    if (copyButton) copyCode(copyButton);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !popup.hidden) dismiss();
  });

  if (wasRecentlyDismissed()) return;
  timer = window.setTimeout(show, isPreviewMode ? 250 : delay);
  window.addEventListener('scroll', onScroll, { passive: true });
})();
